//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Die.js";
import "../Features/Features.Feature.js";
import "../no/ScCollector.js";
let d=[[],[[["all_tips"],"CreateDieData",{},1,0],[[],"DeleteDieData",{},0,0],[[],"DisplayDieData",{},0,0],[[],"UndisplayDieData",{},0,0],[["point"],"TransformDiePoint",{},1,0],[["vector"],"TransformDieDirection",{},1,0],[["objects"],"SetReferenceCurves",{},1,0],[["collector"],"MapCollectorToPart",{},1,0],[["collector"],"MapCollectorToDie",{},1,0],[["in_edge","part_edge","die_edge"],"MapEdge",{},1,0],[["num_edges"],"GetUnprocessedHoles",{R_:{edges:"Edge[]"}},0,0],[["objects"],"AddToDieData",{},1,0]],[]];
SPLM.Die.Tip = class extends SPLM.Features.Feature{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Die.Tip";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;